import React, { useEffect, useMemo, useState } from "react";
import Header from "../../../../Components/Header";
import SingleSignOnSideBar from "../../../../Components/SingleSignOnSideBar";
import performanceReportnavigate from "../../../../asset/images/ibaimages/performanceReportNavigate.svg";
import { HighchartsReact } from "highcharts-react-official";
import Highcharts from "highcharts";
import { IBA_Admin_Section } from "../../../../Configuration/API_URL";
import { Button, Modal } from "react-bootstrap";
import IBADuration from "../../../IBAAdmin/IBADuration";
import moment from "moment";
import backDetails from '../../../../asset/images/ibaimages/backDetails.svg';
import { useLocation, useNavigate } from "react-router-dom";
import { axiosInstance0 } from "../../../../CommonMethhods/axiosInstance";



const IBAPersonalInsights = () => {
    const sapCode = localStorage.getItem("sapCode")
    const navigate = useNavigate();
    const [revFromDate, setRevFromDate] = useState('');
    const [revToDate, setRevToDate] = useState('');
    const [revDuration, setRevDuration] = useState('yesterday');
    const [revData, setRevData] = useState([]);
    const [accOpenData, setAccOpenData] = useState([]);

    const [accFromDate, setAccFromDate] = useState('');
    const [accToDate, setAccToDate] = useState('');
    const [accDuration, setAccDuration] = useState('yesterday');
    const location = useLocation();
    const selectedAgent = location?.state?.agent;


    const getRevenueGrapgh = async () => {
        const payload = {
            from_date: revFromDate,
            to_date: revToDate,
            sapcode: sapCode
        }
        try {
            const response = await axiosInstance0.post(
                IBA_Admin_Section.RevenueEarnedGraph,
                payload,

            );
            const data = await response.data;
            if (data.status === 0) {
                setRevData(data?.data || []);
            } else {
                setRevData([]);
            }
        } catch (err) {
            console.log(err);
            setRevData([]);
        }
    };

    const getAccOpenGrapgh = async () => {
        const payload = {
            from_date: accFromDate,
            to_date: accToDate,
            sapcode: sapCode
        }
        try {
            const response = await axiosInstance0.post(
                IBA_Admin_Section.AccountsOpenedGraph,
                payload,

            );
            const data = await response.data;
            if (data.status === 0) {
                setAccOpenData(data?.data || []);
            } else {
                setAccOpenData([]);
            }
        } catch (err) {
            console.log(err);
            setAccOpenData([]);
        }
    };

    useEffect(() => {
        if (revFromDate && revToDate) {
            getRevenueGrapgh();
        }
    }, [revFromDate, revToDate]);

    useEffect(() => {
        if (accFromDate && accToDate) {
            getAccOpenGrapgh();
        }
    }, [accFromDate, accToDate]);

    const { categories, seriesData } = useMemo(() => {
        return {
            categories: revData.map(item =>
                moment(item.dateValue).format("DD MMM")
            ),
            seriesData: revData.map(item => item.revenueEarnedCount)
        };
    }, [revData]);

    console.log(accDuration, revDuration, accFromDate, accToDate, "accDuration");

    const revenueChartOptions = {
        chart: {
            type: "area",
            backgroundColor: "transparent",
            height: 320
        },

        title: { text: null },
        credits: { enabled: false },
        legend: { enabled: false },

        xAxis: {
            categories,
            tickmarkPlacement: "on",
            tickLength: 6,
            tickWidth: 1,
            tickColor: "#9CA3AF",

            lineWidth: 1,
            lineColor: "#9CA3AF",


            labels: {
                style: {
                    fontSize: "12px",
                    color: "#6B7280"
                }
            }
        },

        yAxis: {
            title: {
                text: "In Rupees",
                align: "middle",
                margin: 30,
                style: {
                    fontSize: "12px",
                    color: "#6B7280",
                    fontWeight: 500
                }
            },
            gridLineWidth: 0,
            lineWidth: 1,
            lineColor: "#9CA3AF",

            labels: {
                //   formatter: function () {
                //     return `${this.value}`;
                //   },
                formatter: function () {
                    if (this.value >= 1000) {
                        return this.value / 1000 + "K";
                    }
                    return this.value;
                },
                style: {
                    fontSize: "12px",
                    color: "#6B7280"
                }
            }
        },

        tooltip: {
            shared: true,
            formatter: function () {
                return `<b>₹ ${this.y}</b>`;
            }
            // valueSuffix: ""
        },

        plotOptions: {
            area: {
                marker: {
                    enabled: false
                },
                lineWidth: 2,
                //   states: {
                //     hover: {
                //       lineWidth: 2
                //     }
                //   }
            }
        },

        series: [
            {
                name: "Revenue Earned",
                data: seriesData,
                color: "#22C55E",
                fillColor: {
                    linearGradient: {
                        x1: 0,
                        y1: 0,
                        x2: 0,
                        y2: 1
                    },
                    stops: [
                        [0, "rgba(34, 197, 94, 0.6)"],
                        [1, "rgba(34, 197, 94, 0.05)"]
                    ]
                }
            }
        ]
    };

    const { accCategories, accSeriesData } = useMemo(() => {
        return {
            accCategories: accOpenData.map(item =>
                moment(item.dateValue).format("DD MMM")
            ),
            accSeriesData: accOpenData.map(item => item.accountsOpenedCount)
        };
    }, [accOpenData]);

    const accOpenChartOptions = {
        chart: {
            type: "area",
            backgroundColor: "transparent",
            height: 320
        },

        title: { text: null },
        credits: { enabled: false },
        legend: { enabled: false },

        xAxis: {
            categories: accCategories,
            tickmarkPlacement: "on",
            tickLength: 6,
            tickWidth: 1,
            tickColor: "#9CA3AF",

            lineWidth: 1,
            lineColor: "#9CA3AF",


            labels: {
                style: {
                    fontSize: "12px",
                    color: "#6B7280"
                }
            }
        },

        yAxis: {
            title: {
                text: "Accounts",
                align: "middle",
                margin: 30,
                style: {
                    fontSize: "12px",
                    color: "#6B7280",
                    fontWeight: 500
                }
            },
            gridLineWidth: 0,
            lineWidth: 1,
            lineColor: "#9CA3AF",

            labels: {
                formatter: function () {
                    return this.value;
                },
                style: {
                    fontSize: "12px",
                    color: "#6B7280"
                }
            }
        },

        tooltip: {
            shared: true,
            formatter: function () {
                return `<b>${this.y}</b>`;
            }
            // valueSuffix: ""
        },

        plotOptions: {
            area: {
                marker: {
                    enabled: false
                },
                lineWidth: 2,
                //   states: {
                //     hover: {
                //       lineWidth: 2
                //     }
                //   }
            }
        },

        series: [
            {
                name: "Accounts Opened",
                data: accSeriesData,
                color: "#1C74D0",
                fillColor: {
                    linearGradient: {
                        x1: 0,
                        y1: 0,
                        x2: 0,
                        y2: 1
                    },
                    stops: [
                        [0, "rgba(28, 116, 208, 0.5)"],
                        [1, "rgba(28, 116, 208, 0.08)"]
                    ]
                }
            }
        ]
    };

    useEffect(() => {
        const yesterday = moment().subtract(1, "day").format("MM-DD-YYYY");
        // Revenue
        setRevDuration("yesterday");
        setRevFromDate(yesterday);
        setRevToDate(yesterday);

        // Accounts
        setAccDuration("yesterday");
        setAccFromDate(yesterday);
        setAccToDate(yesterday);
    }, []);


    const backNavigate = () => {
        navigate("/performance-reports")
    }

    return (
        <div>
            <Header portal={"IBA"} />
            <SingleSignOnSideBar />
            <main id="main-content" className="telecallerDash">
                <div className='card-box iba-page'>
                    <div className="agent-table-wrapper">
                        <div className='main-header-title'>
                            <div className="wrap-header report-head">
                                <img style={{ cursor: "pointer" }} src={backDetails} alt="backDetails" onClick={() => backNavigate()} />
                                <div className='module-title'>Personal Insights</div>
                            </div>
                        </div>
                    </div>

                    <div className="personal-insight">
                        <div className="wrap-card">
                            <div className="wrap-head">
                                <span className="card-title">Revenue Earned</span>

                                <IBADuration
                                    setFromDate={setRevFromDate}
                                    setToDate={setRevToDate}
                                    setSelectDuration={setRevDuration}
                                    selectDuration={revDuration}
                                    label="iba-performance"
                                />
                            </div>

                            <div className="wrap-graph">
                                <div style={{ width: "95%" }} className="overview-div">
                                    <HighchartsReact
                                        highcharts={Highcharts}
                                        options={revenueChartOptions}
                                    />
                                </div>
                            </div>

                        </div>

                        <div className="wrap-card">
                            <div className="wrap-head">
                                <span className="card-title">Accounts Opened</span>

                                <IBADuration
                                    setFromDate={setAccFromDate}
                                    setToDate={setAccToDate}
                                    setSelectDuration={setAccDuration}
                                    selectDuration={accDuration}
                                    label="iba-performance"
                                />
                            </div>
                            <HighchartsReact
                                highcharts={Highcharts}
                                options={accOpenChartOptions}
                            />

                        </div>

                    </div>
                </div>
            </main>
        </div>
    );
};

export default IBAPersonalInsights;
